import { render, staticRenderFns } from "./UserApproval.vue?vue&type=template&id=443ba6e3"
import script from "./UserApproval.vue?vue&type=script&lang=js"
export * from "./UserApproval.vue?vue&type=script&lang=js"
import style0 from "./UserApproval.vue?vue&type=style&index=0&id=443ba6e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports